(() => {
  const adjust_text_area = (textarea) => {
    textarea.style.height = 'auto';

    const max_rows = 5;
    const target = window.getComputedStyle(textarea);
    const line_height = parseInt(target.lineHeight, 10);
    const padding_top = parseInt(target.paddingTop, 10);
    const padding_bottom = parseInt(target.paddingBottom, 10);
    const border_top = parseInt(target.borderTopWidth, 10);
    const border_bottom = parseInt(target.borderBottomWidth, 10);
    const rows = Math.min(Math.floor((textarea.scrollHeight - padding_top - padding_bottom) / line_height), max_rows);
    const textarea_height = (rows * line_height) + padding_top + padding_bottom + border_top + border_bottom;

    textarea.rows = rows;
    textarea.style.height = textarea_height + 'px';
  }

  function initDynamicTextareas() {
    document.querySelectorAll('form textarea.dynamic').forEach((textarea) => {
      textarea.rows = 1;

      adjust_text_area(textarea);

      if (!textarea._dynamicListener) {
        textarea.addEventListener('input', (event) => {
          adjust_text_area(event.target);
        });
        textarea.addEventListener('change', (event) => {
          adjust_text_area(event.target);
        });
        textarea._dynamicListener = true;
      }
    });
  }

  // Initial run
  initDynamicTextareas();

  // Gravity Forms events
  window.addEventListener('gform_post_render', initDynamicTextareas);
  window.addEventListener('gform_page_loaded', initDynamicTextareas);
})();